import {Datagrid} from 'components/refinedev/Datagrid';
import {createColumnHelper} from '@tanstack/react-table';
import Spinner from '@/components/basic/Spinner';
import {CreateButton, EditButton} from 'components/refinedev/action_buttons';
import StaffList from '../staffs/staff-list';
import {BaseID} from '@/hooks/types';
import {useTable} from '@refinedev/core';
import {defaultQueryOptions} from '@/pages/_utils';
import StateBoundary from '@/components/basic/StateBoundary';
import useRefineTanstackDataTable from '@/hooks/refinedev/useRefineTanstackDataTable';
import {DataTable} from '@/components/data-table/data-table';
import DefaultDataTableToolbar from '@/components/refinedev/data-table/DefaultDataTableToolbar';
import {useBulkDelete} from '@/components/refinedev/data-table/use-bulk-delete';

export type StaffInDepartmentManagerProps = {
  department_id: BaseID;
};

/// modify default columns of staff list
const columns = StaffList.table_columns; //.filter(col => !['department'].includes(String(col.id)));
// // .map(col => {
// //   if (col.id === 'actions') {
// //     return columnHelper.display({
// //       id: 'actions',
// //       cell: info => (
// //         <>
// //           <EditButton id={info.row.getValue('id')} resource={'staffs'} />
// //           {/* Add change class button or something */}
// //           {/* <DeleteButtonWithConfirmation id={info.row.getValue('id')} /> */}
// //         </>
// //       ),
// //       header: () => <span />,
// //       meta: {
// //         headerClassName: 'w-12',
// //       },
// //     });
// //   }

//   return col;
// });

const thisResource = 'staffs';

const StaffInDepartmentManager = (props: StaffInDepartmentManagerProps) => {
  const {department_id} = props;

  const {refineTable, tanstackTable} = useRefineTanstackDataTable(
    {
      resource: 'staffs',
      sorters: {initial: [{field: 'id', order: 'asc'}]},
      filters: {initial: [{field: 'department_id', operator: 'eq', value: department_id}]},
      queryOptions: defaultQueryOptions,
      meta: {
        with: ['department', 'job'],
      },
    },
    {columns},
  );
  const bulkDelete = useBulkDelete(thisResource, tanstackTable);

  if (refineTable.tableQuery.isLoading || !refineTable.tableQuery.data) {
    return <Spinner />;
  }

  return (
    <StateBoundary
      isLoading={refineTable.tableQuery.isLoading}
      error={refineTable.tableQuery.error}>
      <div className="p-2">
        <DataTable
          table={tanstackTable}
          toolbar={
            <DefaultDataTableToolbar
              resource={'staffs'}
              table={tanstackTable}
              bulkActions={[bulkDelete]}
            />
          }
        />
      </div>
    </StateBoundary>
  );
};

export default StaffInDepartmentManager;
